import React from 'react'
import './ImageStyleSheet.css';

function EduTwo() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/thsimg2.jpeg" className='img-view'/>
        </div>
    )
}

export default EduTwo
